import { getSupabaseClient } from "./supabase";

/** Team of the signed-in user (the database never trusts a team sent by the client). */
export const getCurrentTeamId = async (): Promise<number> => {
  const { data, error } = await getSupabaseClient().rpc("current_team_id");
  if (error || data == null) {
    throw new Error("Could not find the team of the current user");
  }
  return data as number;
};
